import Vue from 'vue'
import Vuex from 'vuex'

import master from './modules/master'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        loading: false,
        pageOverlay: false
    },
    getters: {
        /*getAutocompleteList: state => {
            return state.autocomplete.data
        }*/
    },
    mutations: {
        
    },
    actions: {
        
    },
    modules: {
        master
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js